<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2018-11-10T15:19:54-09:00
@Email:  ctosterhout@alaska.edu
@Last modified by:   ctosterhout
@Last modified time: 2020-02-17T22:15:58-09:00
@License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
<div class="page-header fixed-top"
     id="pageHeader">
  <PageHeaderLogoMobile />
  <b-navbar toggleable="lg"
            type="light"
            class="page-header-navbar"
            aria-label="Page header navigation"
            variant="light">
    <div class="container">
      <b-navbar-toggle class="mr-auto"
                       :target="idgen('menu-collapse')"></b-navbar-toggle>
      <b-navbar-brand class="page-header-navbar-brand"
                      aria-label="Return to ACRC Home"
                      :href="urlHome">
        <AcrcLogo class="page-header-logo"
                  alt="Alaska Coastal Rainforest Center Logo" />
      </b-navbar-brand>

      <b-collapse is-nav
                  variant="light"
                  class="justify-content-end"
                  :id="idgen('menu-collapse')">
        <NavMenu class="page-header-navmenu"
                 :navitems="navitems" />
        <div class="d-inline-block navbar-nav page-header-search">
          <span class="d-lg-none">
            <a :href="urlSearch" aria-label="Search ACRC" class="nav-link px-1">Search</a>
          </span>
          <span class="d-none d-lg-inline">
            <a :href="urlSearch" aria-label="Search ACRC" class="nav-link mx-2">
              <Icon scale="1.5" name="search"/>
            </a>
          </span>
        </div>
      </b-collapse>
    </div>
  </b-navbar>
</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/modules/variables';
@import '../scss/modules/bootstrap-extend';

.page-header {
    background-color: $page-header-background-color;
    border-bottom: 2px solid $primary;
}

.page-header-navbar-brand {
    padding: $padding-navbar-brand-vertical $padding-navbar-brand-horizontal;
}

.page-header-navbar {
    padding: $padding-header-vertical $padding-header-horizontal;
}

.page-header-logo {
    max-height: $height-header-xs-size;
}

.page-header-navmenu .nav-link,
.page-header-search .nav-link {
    text-transform: uppercase;
    font-size: 1.2rem;
}

@include media-breakpoint-up(lg) {
    .page-header-logo {
        max-height: $height-header-full-size;
    }
}
</style>

<script>
import 'vue-awesome/icons/search'
import Icon from 'vue-awesome/components/Icon'
import generateNonce from 'ernie-core/js/generate-nonce'
import NavMenu from 'ernie-core/components/NavMenu'
import PageHeaderLogoMobile from './PageHeaderLogoMobile'
import defaultNavItems from '../js/default-nav-items'
import AcrcLogo from '../public/static/images/acrc-logo-horizontal.svg?inline'
import urlMangle from '../js/url-mangle'

export default {
  name: '',
  props: {
    navitems: {
      type: Array,
      default: function () {
        return defaultNavItems
      }
    }
  },
  data: function () {
    return {
      nonce: generateNonce(),
      urlHome: '//acrc.alaska.edu',
      urlSearch: urlMangle('/search.html')
    }
  },
  methods: {
    idgen: function (name) {
      return String(`${name}-${this.nonce}`)
    }
  },
  components: {
    NavMenu,
    PageHeaderLogoMobile,
    AcrcLogo,
    Icon
  }
}
</script>
